export type PriceCurrency = 'USD' | 'EUR' | 'GBP';
export const priceCurrencyValues: PriceCurrency[] = [
	'GBP',
	'USD',
	'EUR',
] as const;

export const DEFAULT_CURRENCY: PriceCurrency = 'GBP' as const;
